import React from 'react';
import { SpacerContainer } from './styled';

export interface SpacerProps {
  minWidth?: string;
  maxWidth?: string;
  minHeight?: string;
  maxHeight?: string;
  className?: string;
}

const Spacer = ({ minWidth, maxWidth, minHeight, maxHeight, className }: SpacerProps) => (
  <SpacerContainer
    minWidth={minWidth}
    maxWidth={maxWidth}
    minHeight={minHeight}
    maxHeight={maxHeight}
    className={className}
    aria-hidden={true}
  />
);

Spacer.displayName = 'Spacer';

export default Spacer;
